import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-boldest m-0" }
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "form-group d-flex flex-wrap" }
const _hoisted_9 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "form-group d-flex flex-wrap" }
const _hoisted_12 = { class: "required col-form-label fw-bold fs-6" }
const _hoisted_13 = { class: "col-md-12" }
const _hoisted_14 = { class: "form-group d-flex flex-wrap" }
const _hoisted_15 = { class: "required col-form-label fw-bold fs-6" }
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "form-group d-flex flex-wrap" }
const _hoisted_18 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_19 = { class: "col-md-6" }
const _hoisted_20 = { class: "form-group d-flex flex-wrap" }
const _hoisted_21 = { class: "required col-form-label fw-bold fs-6" }
const _hoisted_22 = { class: "col-md-6" }
const _hoisted_23 = { class: "form-group d-flex flex-wrap" }
const _hoisted_24 = { class: "required col-form-label fw-bold fs-6" }
const _hoisted_25 = { class: "col-md-6" }
const _hoisted_26 = { class: "form-group d-flex flex-wrap" }
const _hoisted_27 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_28 = { class: "col-md-12" }
const _hoisted_29 = { class: "form-group d-flex flex-wrap" }
const _hoisted_30 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_31 = { class: "col-md-6" }
const _hoisted_32 = { class: "form-group d-flex flex-wrap" }
const _hoisted_33 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode("€")
const _hoisted_35 = { class: "col-md-6" }
const _hoisted_36 = { class: "form-group d-flex flex-wrap" }
const _hoisted_37 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_38 = { class: "col-md-6" }
const _hoisted_39 = { class: "form-group d-flex flex-wrap" }
const _hoisted_40 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_41 = { class: "col-md-12" }
const _hoisted_42 = { class: "form-group d-flex flex-wrap" }
const _hoisted_43 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_44 = { class: "col-md-6" }
const _hoisted_45 = { class: "form-group d-flex flex-wrap" }
const _hoisted_46 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_47 = { class: "col-md-6" }
const _hoisted_48 = { class: "form-group d-flex flex-wrap" }
const _hoisted_49 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_50 = { class: "col-md-6" }
const _hoisted_51 = { class: "form-group d-flex flex-wrap" }
const _hoisted_52 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_53 = { class: "col-md-6" }
const _hoisted_54 = { class: "form-group d-flex flex-wrap" }
const _hoisted_55 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_56 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1)
const _hoisted_58 = { class: "svg-icon svg-icon-2" }
const _hoisted_59 = {
  type: "submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_60 = { class: "indicator-label" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1)
const _hoisted_62 = { class: "indicator-progress" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_64 = { class: "card mb-5 mb-xl-10" }
const _hoisted_65 = { class: "card-header border-0" }
const _hoisted_66 = { class: "card-title m-0" }
const _hoisted_67 = { class: "fw-boldest m-0" }
const _hoisted_68 = { class: "card-body border-top p-9" }
const _hoisted_69 = { class: "mb-10" }
const _hoisted_70 = { class: "m-0 ms-n4" }
const _hoisted_71 = ["onClick"]
const _hoisted_72 = { class: "svg-icon svg-icon-3" }
const _hoisted_73 = { class: "card mb-5 mb-xl-10" }
const _hoisted_74 = { class: "card-header border-0" }
const _hoisted_75 = { class: "card-title m-0" }
const _hoisted_76 = { class: "fw-boldest m-0" }
const _hoisted_77 = { class: "card-body border-top p-9" }
const _hoisted_78 = { class: "mb-10" }
const _hoisted_79 = ["innerHTML"]
const _hoisted_80 = ["onClick"]
const _hoisted_81 = { class: "svg-icon svg-icon-3" }
const _hoisted_82 = { class: "card mb-5 mb-xl-10" }
const _hoisted_83 = { class: "card-header border-0" }
const _hoisted_84 = { class: "card-title m-0" }
const _hoisted_85 = { class: "fw-boldest m-0" }
const _hoisted_86 = { class: "card-body border-top p-9" }
const _hoisted_87 = { class: "row" }
const _hoisted_88 = { class: "col-md-6" }
const _hoisted_89 = { class: "form-group d-flex flex-wrap" }
const _hoisted_90 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_91 = { class: "el-form-item__content" }
const _hoisted_92 = { class: "col-md-6" }
const _hoisted_93 = { class: "form-group d-flex flex-wrap" }
const _hoisted_94 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_95 = { class: "el-form-item__content" }
const _hoisted_96 = { class: "col-md-6" }
const _hoisted_97 = { class: "form-group d-flex flex-wrap" }
const _hoisted_98 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_99 = { class: "el-form-item__content" }
const _hoisted_100 = { class: "col-md-6" }
const _hoisted_101 = { class: "form-group d-flex flex-wrap" }
const _hoisted_102 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_103 = { class: "el-form-item__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_permission_common = _resolveComponent("permission-common")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_ShowContentModel = _resolveComponent("ShowContentModel")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_form, {
      onSubmit: _cache[20] || (_cache[20] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
      model: _ctx.formData,
      rules: _ctx.rules,
      ref: "formRef"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.t("common.information")), 1)
            ])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.t("quickInquiry.inquiryId")), 1),
                  _createVNode(_component_el_form_item, { prop: "id" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.id,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.id) = $event)),
                        type: "text",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.t("quickInquiry.taskOwner")), 1),
                  _createVNode(_component_el_form_item, { prop: "task_owner" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.task_owner,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.task_owner) = $event)),
                        filterable: "",
                        remote: "",
                        "reserve-keyword": "",
                        clearable: "",
                        placeholder: _ctx.t('common.plsEnter'),
                        "remote-method": _ctx.searchTaskOwnerItems,
                        loading: _ctx.taskOwnerLoading,
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taskOwnerOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder", "remote-method", "loading"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.t("quickInquiry.request")), 1),
                  _createVNode(_component_el_form_item, { prop: "request" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.request,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.request) = $event)),
                        type: "textarea",
                        placeholder: _ctx.t('common.plsEnter')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.t("quickInquiry.requestedBy")), 1),
                  _createVNode(_component_el_form_item, { prop: "requested_by" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.requested_by,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.requested_by) = $event)),
                        filterable: "",
                        remote: "",
                        "reserve-keyword": "",
                        clearable: "",
                        placeholder: _ctx.t('common.plsEnter'),
                        "remote-method": _ctx.searchRequestedByItems,
                        loading: _ctx.requestedByLoading,
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requestedByOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder", "remote-method", "loading"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.t("quickInquiry.requestDate")), 1),
                  _createVNode(_component_el_form_item, { prop: "request_date" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.formData.request_date,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.request_date) = $event)),
                        type: "date",
                        clearable: "",
                        placeholder: _ctx.t('common.pickDate'),
                        style: {"width":"100%"},
                        onChange: _cache[5] || (_cache[5] = ($event: any) => (
                    _ctx.commonChangeDefaultDate($event, _ctx.formData, 'request_date')
                  ))
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.t("quickInquiry.dueDate")), 1),
                  _createVNode(_component_el_form_item, { prop: "due_date" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.formData.due_date,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.due_date) = $event)),
                        type: "date",
                        placeholder: _ctx.t('common.pickDate'),
                        style: {"width":"100%"},
                        onChange: _cache[7] || (_cache[7] = ($event: any) => (
                    _ctx.commonChangeDefaultDate($event, _ctx.formData, 'due_date')
                  ))
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.t("quickInquiry.quoteDate")), 1),
                  _createVNode(_component_el_form_item, { prop: "quote_date" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.formData.quote_date,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.quote_date) = $event)),
                        type: "date",
                        clearable: "",
                        placeholder: _ctx.t('common.pickDate'),
                        style: {"width":"100%"},
                        "default-value": 
                    _ctx.moment(_ctx.moment().format('YYYY-MM-DD'))
                      .add(12, 'hours')
                      .toISOString()
                  ,
                        onChange: _cache[9] || (_cache[9] = ($event: any) => (
                    _ctx.commonChangeDefaultDate($event, _ctx.formData, 'due_date')
                  ))
                      }, null, 8, ["modelValue", "placeholder", "default-value"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.t("quickInquiry.quote")), 1),
                  _createVNode(_component_el_form_item, { prop: "quote" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.quote,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.quote) = $event)),
                        type: "textarea",
                        placeholder: _ctx.t('common.plsEnter')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.t("quickInquiry.quoteAmount")), 1),
                  _createVNode(_component_el_form_item, { prop: "quote_amount" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.quote_amount,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.quote_amount) = $event)),
                        type: "number",
                        placeholder: _ctx.t('common.plsEnter')
                      }, {
                        prepend: _withCtx(() => [
                          _hoisted_34
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.t("quickInquiry.importance")), 1),
                  _createVNode(_component_el_form_item, { prop: "importance" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio_group, {
                        modelValue: _ctx.formData.importance,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.importance) = $event)),
                        size: "mini"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio, { label: 1 }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("callOutRecords.important")), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_radio, { label: 2 }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("callOutRecords.conventional")), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_radio, { label: 3 }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("callOutRecords.invalid")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.t("quickInquiry.commentTagging")), 1),
                  _createVNode(_component_el_form_item, { prop: "comment_tagging" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.comment_tagging,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.comment_tagging) = $event)),
                        multiple: "",
                        clearable: "",
                        placeholder: _ctx.t('common.plsSelect'),
                        loading: _ctx.commentTaggingLoading,
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commentTaggingOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder", "loading"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.t("quickInquiry.internalComment")), 1),
                  _createVNode(_component_el_form_item, { prop: "internal_comment" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.internal_comment,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.internal_comment) = $event)),
                        type: "textarea",
                        placeholder: _ctx.t('common.plsEnter')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.t("quickInquiry.closeStatus")), 1),
                  _createVNode(_component_el_form_item, { prop: "close_status" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.close_status,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.close_status) = $event)),
                        clearable: "",
                        placeholder: _ctx.t('common.plsSelect'),
                        loading: _ctx.closeStatusLoading,
                        style: {"width":"100%"},
                        disabled: 
                    _ctx.formData.close_date !== '' && _ctx.formData.close_date !== null
                  
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.closeStatusOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder", "loading", "disabled"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("label", _hoisted_49, _toDisplayString(_ctx.t("quickInquiry.closeDate")), 1),
                  _createVNode(_component_el_form_item, { prop: "close_date" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.formData.close_date,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.close_date) = $event)),
                        type: "date",
                        style: {"width":"100%"},
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("label", _hoisted_52, _toDisplayString(_ctx.t("quickInquiry.taskSource")), 1),
                  _createVNode(_component_el_form_item, { prop: "task_source" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.task_source,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.task_source) = $event)),
                        clearable: "",
                        placeholder: _ctx.t('common.plsSelect'),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: _ctx.t('influencerAccount.account'),
                            value: "1"
                          }, null, 8, ["label"]),
                          _createVNode(_component_el_option, {
                            label: _ctx.t('influencerAccount.lead'),
                            value: "2"
                          }, null, 8, ["label"]),
                          _createVNode(_component_el_option, {
                            label: _ctx.t('influencerAccount.callOut'),
                            value: "3"
                          }, null, 8, ["label"]),
                          _createVNode(_component_el_option, {
                            label: _ctx.t('influencerAccount.salesInteraction'),
                            value: "4"
                          }, null, 8, ["label"]),
                          _createVNode(_component_el_option, {
                            label: _ctx.t('influencerAccount.campaign'),
                            value: "5"
                          }, null, 8, ["label"])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_53, [
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("label", _hoisted_55, _toDisplayString(_ctx.t("quickInquiry.campaign")), 1),
                  _createVNode(_component_el_form_item, { prop: "task_source_data_id" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.task_source_data_id,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.task_source_data_id) = $event)),
                        clearable: "",
                        placeholder: _ctx.t('common.plsSelect'),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.campaignOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ], 512), [
                [_vShow, _ctx.formData.task_source == 5]
              ])
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ]),
          _createElementVNode("div", _hoisted_56, [
            _createVNode(_component_router_link, {
              to: '/task-management/quick-inquiry/',
              class: "btn btn-secondary align-self-center me-2"
            }, {
              default: _withCtx(() => [
                _hoisted_57,
                _createTextVNode(_toDisplayString(_ctx.t("common.backToList")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("div", {
                  class: _normalizeClass(["btn btn-success me-2", { disabled: _ctx.closeLoading || _ctx.loading }]),
                  onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.handleCloseStatus && _ctx.handleCloseStatus(...args)))
                }, [
                  _createElementVNode("span", _hoisted_58, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/files/fil007.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.t("common.close")), 1)
                ], 2), [
                  [_vShow, 
              (_ctx.formData.close_date === '' || _ctx.formData.close_date === null) &&
              _ctx.formData.close_status !== '' &&
              !_ctx.closeStatusLoading
            ]
                ]),
                _createElementVNode("button", _hoisted_59, [
                  _createElementVNode("span", _hoisted_60, [
                    _hoisted_61,
                    _createTextVNode(" " + _toDisplayString(_ctx.t("common.saveChanges")), 1)
                  ]),
                  _createElementVNode("span", _hoisted_62, [
                    _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                    _hoisted_63
                  ])
                ], 512)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_64, [
          _createElementVNode("div", _hoisted_65, [
            _createElementVNode("div", _hoisted_66, [
              _createElementVNode("h3", _hoisted_67, _toDisplayString(_ctx.t("quickInquiry.relatedSop")), 1)
            ])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_68, [
            _createElementVNode("div", _hoisted_69, [
              _createVNode(_component_el_table, {
                data: _ctx.options.sop,
                style: {"width":"100%"},
                size: "small",
                "min-width": "220"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: _ctx.t('standardOperatingProcedure.subject'),
                    prop: "subject",
                    width: "180"
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.t('standardOperatingProcedure.checkList')
                  }, {
                    default: _withCtx(({ row }) => [
                      _createElementVNode("div", null, [
                        _createElementVNode("ol", _hoisted_70, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.check_list, (item, index) => {
                            return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(item.check_list), 1))
                          }), 128))
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: "",
                    width: "80",
                    align: "right",
                    role: { auth: ['update'] }
                  }, {
                    default: _withCtx(({ row }) => [
                      _createElementVNode("button", {
                        type: "button",
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#modal_show_content",
                        class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-3",
                        onClick: ($event: any) => (
                    _ctx.showContentModel(
                      _ctx.t('accountValidation.standardOperatingProcedure'),
                      row.check_list
                    )
                  )
                      }, [
                        _createElementVNode("span", _hoisted_72, [
                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                        ])
                      ], 8, _hoisted_71)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"])
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ])
        ]),
        _createElementVNode("div", _hoisted_73, [
          _createElementVNode("div", _hoisted_74, [
            _createElementVNode("div", _hoisted_75, [
              _createElementVNode("h3", _hoisted_76, _toDisplayString(_ctx.t("quickInquiry.standardScript")), 1)
            ])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_77, [
            _createElementVNode("div", _hoisted_78, [
              _createVNode(_component_el_table, {
                data: _ctx.options.standard_script,
                style: {"width":"100%"},
                size: "small",
                "min-width": "220"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: _ctx.t('standardScript.subject'),
                    prop: "subject",
                    width: "180"
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.t('accountValidation.script')
                  }, {
                    default: _withCtx(({ row }) => [
                      _createElementVNode("div", {
                        innerHTML: row.script,
                        class: "pt-4"
                      }, null, 8, _hoisted_79)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: "",
                    width: "80",
                    align: "right",
                    role: { auth: ['update'] }
                  }, {
                    default: _withCtx(({ row }) => [
                      _createElementVNode("button", {
                        type: "button",
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#modal_show_content",
                        class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-3",
                        onClick: ($event: any) => (
                    _ctx.showContentModel(
                      _ctx.t('accountValidation.standardScript'),
                      row.script
                    )
                  )
                      }, [
                        _createElementVNode("span", _hoisted_81, [
                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                        ])
                      ], 8, _hoisted_80)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"])
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ])
        ])
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _createElementVNode("div", _hoisted_82, [
      _createElementVNode("div", _hoisted_83, [
        _createElementVNode("div", _hoisted_84, [
          _createElementVNode("h3", _hoisted_85, _toDisplayString(_ctx.t("common.historyLog")), 1)
        ])
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_86, [
        _createElementVNode("div", _hoisted_87, [
          _createElementVNode("div", _hoisted_88, [
            _createElementVNode("div", _hoisted_89, [
              _createElementVNode("label", _hoisted_90, _toDisplayString(_ctx.t("common.creator")), 1),
              _createElementVNode("div", _hoisted_91, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.__show.created_user,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formData.__show.created_user) = $event)),
                  type: "text",
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_92, [
            _createElementVNode("div", _hoisted_93, [
              _createElementVNode("label", _hoisted_94, _toDisplayString(_ctx.t("common.creationDate")), 1),
              _createElementVNode("div", _hoisted_95, [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.formData.created_at,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formData.created_at) = $event)),
                  type: "datetime",
                  style: {"width":"100%"},
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_96, [
            _createElementVNode("div", _hoisted_97, [
              _createElementVNode("label", _hoisted_98, _toDisplayString(_ctx.t("common.lastModifiedBy")), 1),
              _createElementVNode("div", _hoisted_99, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.__show.updated_user,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formData.__show.updated_user) = $event)),
                  type: "text",
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_100, [
            _createElementVNode("div", _hoisted_101, [
              _createElementVNode("label", _hoisted_102, _toDisplayString(_ctx.t("common.lastModifiedDate")), 1),
              _createElementVNode("div", _hoisted_103, [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.formData.updated_at,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formData.updated_at) = $event)),
                  type: "datetime",
                  style: {"width":"100%"},
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ])
        ])
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _createVNode(_component_ShowContentModel, {
      title: _ctx.showTitle,
      content: _ctx.showContent
    }, null, 8, ["title", "content"])
  ], 64))
}